module.exports = __webpack_public_path__ + "static/media/Bupa Web UI.5e8c2132.png";